import { processCsvData } from 'kepler.gl/processors';
import { addDataToMap } from "kepler.gl/actions";

const MUNICIPAL_INFRACTION_DATA = "/icon_municipal_data.csv";

export const fetchAndProcessMunicipalInfractionData = async (setLayerDataState, dispatch, store) => {
    let municipalCSVString;
    try {
        const response = await fetch(MUNICIPAL_INFRACTION_DATA);
        if (!response.ok) {
            console.error('Invalid Municipal CSV data', response.statusText);
        }

        // Parse the JSON data
        municipalCSVString = await response.text();
        if (!municipalCSVString) {
            console.error('Invalid Municipal CSV data');
        }

    } catch(error) {
        console.error('Error fetching Municipal CSV data:', error);
    }

    setLayerDataState((prev) => ({ ...prev, municipalInfractions: municipalCSVString }));

    // Store the fetched data in Redux
    dispatch({ type: 'STORE_TRANSFORMED_MUNICIPAL_DATA', payload: processCsvData(municipalCSVString)});
    
    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "Municipal", id: "municipal" },
                    data: processCsvData(municipalCSVString)
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
            visState: {
                interactionConfig: {
                    tooltip: {
                        id: 'tooltip',
                        enabled : true,
                        compareMode: false,
                        compareType: "absolute",
                        fieldsToShow: {
                            municipal : [
                                { name: 'Infraction Type', format: null },
                            ]
                        }
                    },
                    geocoder: {
                        enabled: true
                    }
                },
                layers: [
                    {
                        "id": "h5kymds",
                        "type": "icon",
                        "config": {
                        "dataId": "municipal",
                        // "columnMode": "points",
                        "label": "Municipal",
                        "color": [
                            30,
                            150,
                            190
                        ],
                        "highlightColor": [
                            252,
                            242,
                            26,
                            255
                        ],
                        "columns": {
                            "lat": "latitude",
                            "lng": "longitude",
                            "icon": "icon"
                        },
                        "isVisible": true,
                        "visConfig": {
                            "radius": 15,
                            "fixedRadius": false,
                            "opacity": 0.8,
                            "outline": false,
                            "thickness": 2,
                            "strokeColor": null,
                            "colorRange": {
                            "colors": [
                                "#ffff99",
                                "#6a3d9a",
                                "#cab2d6",
                                "#ff7f00",
                                "#fdbf6f",
                                "#e31a1c",
                                "#fb9a99",
                                "#33a02c",
                                "#b2df8a",
                                "#1f78b4",
                                "#a6cee3"
                            ],
                            "name": "Uber Viz Qualitative",
                            "type": "qualitative",
                            "category": "Uber"
                            },
                            "strokeColorRange": {
                            "name": "Global Warming",
                            "type": "sequential",
                            "category": "Uber",
                            "colors": [
                                "#4C0035",
                                "#880030",
                                "#B72F15",
                                "#D6610A",
                                "#EF9100",
                                "#FFC300"
                            ]
                            },
                            "radiusRange": [
                            0,
                            50
                            ],
                            "filled": true,
                            "billboard": false,
                            "allowHover": true,
                            "showNeighborOnHover": false,
                            "showHighlightColor": true
                        },
                        "hidden": false,
                        },
                        // visualChannels: {
                        //     colorField: {
                        //         name: "label_class",
                        //         format: "",
                        //         type: "string",
                        //         analyzerType: "STRING",
                        //         fieldIdx: 0,
                        //         id: "label_class",
                        //         displayName: "label_class"
                        //     },
                        // }
                    }
                ]
            }
            }
        })
    );
    
    console.log("Current Map Configuration municipal:", store.getState());

};